<template>
  <div>
    <b-navbar
      toggleable="lg"
      type="dark"
      variant="info"
      fixed="top">
      <b-navbar-brand>
        <router-link to="/">
          <img
            src="@/assets/images/common/logo.png"
            class="logo"
          >
        </router-link>
      </b-navbar-brand>
      <b-navbar-toggle
        target="nav-collapse">
      </b-navbar-toggle>
      <b-collapse id="nav-collapse" is-nav>
        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <b-nav-item to="/kayaks" activeClass="active">Kayaks</b-nav-item>
          <b-nav-item to="/paddles" activeClass="active">Pagaie</b-nav-item>
          <b-nav-item to="/accessories" activeClass="active">Accessori</b-nav-item>
          <b-nav-item to="/offers" activeClass="active">Offerte</b-nav-item>
          <b-nav-item to="/contacts" activeClass="active">Contatti</b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>
<script>
export default {
  name: 'sub-nav-bar'
}
</script>
